import { PropsWithChildren, useMemo, useState } from 'react'
import { DebugModeContext } from './useDebugMode'

export const DebugModeProvider = ({ children }: PropsWithChildren) => {
  const [debugSuppressed, setDebugSuppressed] = useState(false)

  const value = useMemo(
    () => ({ debugSuppressed, setDebugSuppressed }),
    [debugSuppressed]
  )

  return <DebugModeContext.Provider value={value}>{children}</DebugModeContext.Provider>
}
